
import { mapState, mapMutations, mapGetters } from 'vuex'
import SearchBox from '~/components/Research/SearchBox'
import TabMenu from '~/components/Common/UI/TabMenu.vue'
import api from '~/api/'
import { getToday } from '~/utils'
import ResearchPaging from '~/components/Research/ResearchPaging'

export default {
    components: {
        TabMenu,
        SearchBox,
        ResearchPaging,
    },
    data() {
        return {
            curPage: 1,         // 현재페이지
            countByPage: 25,    // 한페이지당 갯수
            date: null,         // params.date
            stockCode : null,   // params.stockCode
            companyCode : null, // params.companyCode
            componentKey: 0,
            stockRecom: {
                items: [],
            },
            selectSearch: 'corp',
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
        ...mapState('tabs', ['tabGroup']),
        ...mapState('search', ['company']),

        // 전체 글의 수
        setTotalCount() {
            let count = 0
            if (this.stockRecom.items.length > 0) {
                count = this.stockRecom.totalCount
            }
            return count
        },
    },
    watch: {
        company() {
            // 220519 meej 페이징 추가로 인한 변경
            // this.getListData({ companyCode: this.company.code }) 
            this.initParams()
            this.companyCode = this.company.code
            this.getListData()
        },
        stockRecom() {
            // 플리커링 때문에 임시 주석 처리
            this.forceRerender()
        },
    },
    created() {
        this.getListData()
        this.TABSCONTENT_SET({
            tabGroup: 'Research',
            onTab: 'DailyRecommend',
        })
    },
    methods: {
        ...mapMutations('tabs', ['TABSCONTENT_SET']),

        // params 초기화
        initParams(){
            this.date = null
            this.stockCode = null
            this.companyCode = null
            this.curPage = 1
            this.countByPage = 25
        },
        // 페이지 번호 클릭시 
        onClickPage(page) {
            this.curPage = page
            this.getListData()
        },
        async getListData() {
            // 220519 meej 페이징 추가로 인한 변경
            // const params = { ...value }
            const params = { 
                    pageNo: this.curPage,
                    countByPage: this.countByPage,
                    stockCode : this.stockCode,
                    date : this.date,
                    companyCode : this.companyCode
                }

            // const today = getToday()
            // params.date =  today
            const res = await api.getDailyRecommend(params)
            this.stockRecom = res.data
        },
        onClickitem(id) {
            // event.target 으로 변경예정
            // console.log(event)
            const el = document.getElementById(id)
            if (el.style.display === 'table-row') {
                el.style.display = 'none'
            } else {
                el.style.display = 'table-row'
            }
        },
        /* 20210510 shb 추가 */
        forceRerender() {
            this.componentKey += 1
        },
        /* 20210524 shb 추가 */
        getCorpSearch(value) {
            // 220519 meej 페이징 추가로 인한 변경
            // this.getListData({ stockCode: value })
            this.initParams()
            this.stockCode = value
            this.getListData()
        },
        getDateSearch(value) {
            // 220519 meej 페이징 추가로 인한 변경
            // this.getListData({ date: value })
            this.initParams()
            if(value !== 'Invalid Date'){
                this.date = value
            }
            this.getListData()
        },
    },
}
